import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  Modal,
  TextArea,
  TextField,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { useAddToBlackList } from "@/features/black-list/use-black-list.ts";

interface IFormInput {
  phone: string;
  reason: string;
}

export function AddBlackListModal() {
  const [isOpen, setIsOpen] = useState(false);

  const addMutation = useAddToBlackList();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    addMutation
      .mutateAsync({
        phone: data.phone.trim(),
        reason: data.reason.trim(),
      })
      .then(() => {
        reset();
        setIsOpen(false);
      });
  };

  return (
    <div>
      <Button variant="primary" onPress={() => setIsOpen(true)}>
        Добавить номер
        <Icon className="size-6" icon="solar:add-circle-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Header>
                  <Modal.Heading>Добавить номер в чёрный список</Modal.Heading>
                </Modal.Header>
                <Modal.Body className="flex flex-col gap-4">
                  <TextField isInvalid={!!errors.phone?.message}>
                    <Label>Номер телефона</Label>
                    <Input
                      placeholder="+7 777 123 45 67"
                      {...register("phone", {
                        required: "Нужно заполнить поле",
                        validate: (value) =>
                          value.replace(/\D/g, "").length >= 10 ||
                          "Слишком короткий номер",
                      })}
                    />
                    <FieldError>{errors.phone?.message}</FieldError>
                  </TextField>

                  <TextField>
                    <Label>Причина</Label>
                    <TextArea
                      placeholder="Например: клиент просил не слать SMS"
                      rows={3}
                      {...register("reason")}
                    />
                  </TextField>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="danger-soft"
                    onPress={() => setIsOpen(false)}
                  >
                    Отмена
                  </Button>

                  <Button
                    isPending={addMutation.isPending}
                    type="submit"
                    variant="primary"
                  >
                    Добавить
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
